var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const onGetMe = meData => {
  if (!window.CryptoJS) {
    setTimeout(() => onGetMe(meData), 2000);
    return;
  }
  window.dataLayer.push({
    session: {
      user: {
        userID: meData.publicAccountId,
        loginType: meData.loginType,
        md5_email: window.CryptoJS.MD5((meData === null || meData === void 0 ? void 0 : meData.email) || '').toString(),
        md5_gender: window.CryptoJS.MD5((meData === null || meData === void 0 ? void 0 : meData.gender) || '').toString(),
        md5_phone: window.CryptoJS.MD5((meData === null || meData === void 0 ? void 0 : meData.phone) || '').toString(),
        md5_zip_code: window.CryptoJS.MD5((meData === null || meData === void 0 ? void 0 : meData.zipCode) || '').toString(),
        sha256_email: window.CryptoJS.SHA256((meData === null || meData === void 0 ? void 0 : meData.email) || '').toString(),
        sha256_gender: window.CryptoJS.SHA256((meData === null || meData === void 0 ? void 0 : meData.gender) || '').toString(),
        sha256_phone: window.CryptoJS.SHA256((meData === null || meData === void 0 ? void 0 : meData.phone) || '').toString(),
        sha256_zip_code: window.CryptoJS.SHA256((meData === null || meData === void 0 ? void 0 : meData.zipCode) || '').toString(),
        account_type: meData.company ? 'profissional' : 'privado',
        email_verified: meData.emailVerified,
        phone_verified: meData.phoneVerified
      }
    }
  });
};
export const getMe = (teamKey, signal) => __awaiter(void 0, void 0, void 0, function* () {
  let meData = {};
  try {
    const response = yield fetch("https://apigw.olx.com.br/v2/me?X-OLX-TEAM-KEY=".concat(teamKey || 'hQIPDF7Bfpw2WJUDwr9GV21jIoDSEJGl'), {
      credentials: 'include',
      signal
    });
    if (response.status !== 200) return meData;
    const json = yield response.json();
    if (!json) return meData;
    meData = json;
    onGetMe(meData);
  } catch (error) {
    /* empty */
  }
  return meData;
});